import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
  },
  checkboxIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    background: '#F0F3F7',
    border: '1px solid #D3D9DF',
  },
  checkedCheckboxIcon: {
    background: '#218D7A',
    borderColor: '#218D7A',
  },
  checkIcon: {
    fontSize: 'unset',
    color: '#fff',
  },
  indeterminateIcon: {
    fontSize: 'unset',
    color: theme.custom.darkBlue,
  },
  checkboxRoot: {
    padding: 0,
    color: '#218D7A',
    // '& input:disabled ~ $checkboxIcon': {
    //   background: theme.color.greyLight2,
    //   borderColor: theme.color.greyBorder,
    // },
    // '& input:disabled ~ $checkedCheckboxIcon': {
    //   background: theme.color.greyBorder,
    //   borderColor: theme.color.greyBorder,
    // },
  },
  colorSecondary: {
    '&.Mui-disabled': {
      opacity: 0.3,
    },
  },
}));
